var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-toggle flex-center"},[_c('a',{attrs:{"title":_vm.title},on:{"click":function($event){return _vm.setLanguage()}}},[_c('span',{staticClass:"flag-icon flag-icon-large",class:_vm.flag})])])}
var staticRenderFns = []

export { render, staticRenderFns }